import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import TopBar from "@/components/TopBar";
import NavPane from "@/components/NavPane";

export default function HostSetup() {
  const navigate = useNavigate();
  // Iter 137: difficulty levels removed.  All matches use "medium".
  const difficulty = "medium";
  const [name, setName] = useState("");

  const proceed = () => {
    const trimmed = name.trim().slice(0, 20) || "Player 1";
    const params = new URLSearchParams({
      difficulty,
      p1: trimmed,
      avatar: "",
    });
    navigate(`/game?${params.toString()}`);
  };

  return (
    <div className="wupong-stage relative min-h-screen overflow-x-clip wupong-bg" data-testid="host-setup-page">
      <div className="wupong-grain pointer-events-none absolute inset-0" />

      <TopBar
        theme="wupong"
        onBack={() => navigate("/pong-tournament")}
        backLabel="BACK"
        testId="host-setup-back-button"
      />

      <div className="relative z-10 max-w-7xl mx-auto flex flex-col md:flex-row">
        <div
          className="md:w-[260px] md:shrink-0 md:min-h-screen flex flex-col pt-4 md:pt-6 px-4 md:px-6 pb-6 md:border-r"
          style={{ borderColor: "rgba(192,132,252,0.18)" }}
        >
          <NavPane theme="wupong" />
        </div>
        <div className="flex-1 px-6 md:px-10 pt-8 pb-16">
          <div className="mb-10">
            <div
              className="wupong-stencil text-[10px] tracking-[0.4em] uppercase mb-3"
              style={{ color: "#C084FC" }}
            >
              Defense · Host
            </div>
            <h1
              className="wupong-headline text-6xl md:text-7xl"
              style={{
                color: "#C084FC",
                textShadow: "3px 3px 0 #6D28D9",
              }}
              data-testid="host-setup-title"
            >
              HOST A MATCH
            </h1>
            <div className="wupong-tag" />
          </div>

          <div className="space-y-5 max-w-md p-6 mb-8" style={{ background: "rgba(26,24,20,0.85)", border: "2px solid #C084FC", boxShadow: "5px 5px 0 #6D28D9" }}>
            <div>
              <div className="wupong-mono text-[10px] tracking-[0.3em] uppercase mb-2" style={{ color: "#C084FC" }}>Your Name</div>
              <input
                className="w-full text-xl tracking-wider"
                style={{
                  background: "transparent",
                  border: "none",
                  borderBottom: "2px solid #C084FC",
                  color: "#C084FC",
                  outline: "none",
                  padding: "0.5rem 0",
                  fontFamily: "'Playfair Display', serif",
                }}
                value={name}
                onChange={(e) => setName(e.target.value.slice(0, 20))}
                placeholder="Anonymous"
                maxLength={20}
                data-testid="host-setup-name-input"
              />
            </div>
          </div>

          <div className="flex justify-center">
            <button
              onClick={proceed}
              className="wupong-cta inline-flex items-center gap-3"
              data-testid="host-setup-proceed-button"
            >
              TAKE THE FIELD <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
